
// // Imports
// import andreas from "../../assets/Orators/andreas_m_papas.jpg";
// import maria from "../../assets/Orators/maria_richards_brown.jpg";
// import rassa from "../../assets/Orators/rassa_pegahi.jpg";
// import anna from "../../assets/Orators/anna_sobanska.jpg";
// import barbara from "../../assets/Orators/barbara_de_filippis.jpg";
// import priya from "../../assets/Orators/priya_hays.jpg";
// import teresa from "../../assets/Orators/teresa_carvajal.jpg";
// import huiqin from "../../assets/Orators/huiqin_yang.jpg";

// // Banner imports
// import andreas_banner from "../../assets/Orator Banners/andreas_m_papas_banner.jpg";
// import maria_banner from "../../assets/Orator Banners/maria_richards_brown_banner.jpg";
// import rassa_banner from "../../assets/Orator Banners/rassa_pegahi_banner.jpg";
// import anna_banner from "../../assets/Orator Banners/anna_sobanska_banner.jpg";
// import barbara_banner from "../../assets/Orator Banners/barbara_de_filippis_banner.jpg";
// import priya_banner from "../../assets/Orator Banners/priya_hays_banner.jpg";
// import teresa_banner from "../../assets/Orator Banners/teresa_carvajal_banner.jpg";
// import huiqin_banner from "../../assets/Orator Banners/huiqin_yang_banner.jpg";

// export const orators = [
//   {
//     id: "andreas-m-papas",
//     image: andreas,
//     name: "Dr. Andreas M Papas",
//     from: "USA",
//     about: "Adjunct Professor",
//     link: "/world-GENT-orators/andreas-m-papas",
//   },
//   {
//     id: "maria-richards-brown",
//     image: maria,
//     name: "Maria Richards Brown",
//     from: "United Kingdom",
//     about: "Research Assistant",
//     link: "/world-GENT-orators/maria-richards-brown",
//   },
//   {
//     id: "rassa-pegahi",
//     image: rassa,
//     name: "Dr. Rassa Pegahi",
//     from: "France",
//     about: "PhD in Molecular Biology",
//     link: "/world-GENT-orators/rassa-pegahi",
//   },
//   {
//     id: "anna-w-sobanska",
//     image: anna,
//     name: "Dr. Anna W. Sobańska",
//     from: "Poland",
//     about: "PhD in Organic Chemistry",
//     link: "/world-GENT-orators/anna-w-sobanska",
//   },
//   {
//     id: "barbara-de-filippis",
//     image: barbara,
//     name: "Prof. Barbara De Filippis",
//     from: "Italy",
//     about: "Associate Professor in Medicinal Chemistry, University of Chieti",
//     link: "/world-GENT-orators/barbara-de-filippis",
//   },
//   {
//     id: "priya-hays",
//     image: priya,
//     name: "Dr. Priya Hays",
//     from: "USA",
//     about: "Science Writer and Author",
//     link: "/world-GENT-orators/priya-hays",
//   },
//   {
//     id: "teresa-carvajal",
//     image: teresa,
//     name: "Dr. Teresa Carvajal",
//     from: "USA",
//     about: "Faculty Member at Purdue University",
//     link: "/world-GENT-orators/teresa-carvajal",
//   },
//   {
//     id: "huiqin-yang",
//     image: huiqin,
//     name: "Dr. Huiqin Yang",
//     from: "United Kingdom",
//     about: "Senior Research Fellow",
//     link: "/world-GENT-orators/huiqin-yang",
//   },
// ];

// // Detailed orator data

// export const andreas_m_papas_data = {
//   id: "andreas-m-papas",
//   image: andreas,
//   from: "USA",
//   name: "Dr. Andreas M Papas",
//   banner: andreas_banner,
//   about:
//     "Dr. Papas is Adjunct Professor of the College of Medicine, East Tennessee State University and CEO and member of the Board of Directors of Antares Health Products, Inc. A Fulbright Scholar and author of 'The Vitamin E Factor', he developed product concepts with NIH-supported clinical evaluation, formulation, and commercial production expertise.",
// };

// export const maria_richards_brown_data = {
//   id: "maria-richards-brown",
//   image: maria,
//   from: "United Kingdom",
//   name: "Maria Richards Brown",
//   banner: maria_banner,
//   about:
//     "Maria Richards-Brown is a research assistant at UCL, with a background in Experimental Psychology from Oxford and MSc in Clinical Mental Health Sciences. She worked on pharmacogenetics studies focusing on patient and clinician feedback regarding antipsychotic drug reactions.",
// };

// export const rassa_pegahi_data = {
//   id: "rassa-pegahi",
//   image: rassa,
//   from: "France",
//   name: "Dr. Rassa Pegahi",
//   banner: rassa_banner,
//   about:
//     "Dr. Pegahi earned a PhD in Molecular Biology and has 7 years of oncology experience in hospital and pharmaceutical industry, specializing in medical affairs and clinical trials.",
// };

// export const anna_w_sobanska_data = {
//   id: "anna-w-sobanska",
//   image: anna,
//   from: "Poland",
//   name: "Dr. Anna W. Sobańska",
//   banner: anna_banner,
//   about:
//     "Dr. Sobańska earned a PhD in Organic Chemistry from Oxford and has worked as a formulation chemist at Pollena-Ewa Cosmetic Factory in Poland.",
// };

// export const barbara_de_filippis_data = {
//   id: "barbara-de-filippis",
//   image: barbara,
//   from: "Italy",
//   name: "Prof. Barbara De Filippis",
//   banner: barbara_banner,
//   about:
//     "Prof. De Filippis is Associate Professor in Medicinal Chemistry at the University of Chieti, focusing on small molecule anticancer and antimicrobial research.",
// };

// export const priya_hays_data = {
//   id: "priya-hays",
//   image: priya,
//   from: "USA",
//   name: "Dr. Priya Hays",
//   banner: priya_banner,
//   about:
//     "Dr. Hays is an accomplished science writer with over twenty publications and five books, serving also as a guest editor on cancer immunotherapies.",
// };

// export const teresa_carvajal_data = {
//   id: "teresa-carvajal",
//   image: teresa,
//   from: "USA",
//   name: "Dr. Teresa Carvajal",
//   banner: teresa_banner,
//   about:
//     "Dr. Carvajal is faculty at Purdue University with a focus on material sciences impacting pharmaceutical formulations and manufacturing.",
// };

// export const huiqin_yang_data = {
//   id: "huiqin-yang",
//   image: huiqin,
//   from: "United Kingdom",
//   name: "Dr. Huiqin Yang",
//   banner: huiqin_banner,
//   about:
//     "Dr. Yang is Senior Research Fellow in Health Technology Assessment at University of Exeter with extensive HTA experience for NICE and NIHR programs.",
// };

// // Map for lookup

// export const orators_details_map = {
//   "andreas-m-papas": andreas_m_papas_data,
//   "maria-richards-brown": maria_richards_brown_data,
//   "rassa-pegahi": rassa_pegahi_data,
//   "anna-w-sobanska": anna_w_sobanska_data,
//   "barbara-de-filippis": barbara_de_filippis_data,
//   "priya-hays": priya_hays_data,
//   "teresa-carvajal": teresa_carvajal_data,
//   "huiqin-yang": huiqin_yang_data,
// };


// Imports for profile images
import mohammedSaadAlGhamdi from "../../assets/Orators/mohammed-saad-al-ghamdi.jpg";
import markHoffmann from "../../assets/Orators/mark-hoffmann.jpg";
import jungHoonPark from "../../assets/Orators/jung-hoon-park.jpg";
import stanislawDzwigaj from "../../assets/Orators/stanislaw-dzwigaj.jpg";
import haiboGe from "../../assets/Orators/haibo-ge.jpg";
import yongSooKim from "../../assets/Orators/yong-soo-kim.jpg";
import yaxinSu from "../../assets/Orators/yaxin-su.jpg";
import sabahBaqi from "../../assets/Orators/sabah-baqi.jpg";
import inayathAliKhan from "../../assets/Orators/inayath-ali-khan.jpg";
import beatriceVincenti from "../../assets/Orators/beatrice-vincenti.jpg";

// Imports for banner images
import mohammedSaadAlGhamdiBanner from "../../assets/Orator Banners/mohammed-saad-al-ghamdi_banner.jpg";
import markHoffmannBanner from "../../assets/Orator Banners/mark-hoffmann_banner.jpg";
import jungHoonParkBanner from "../../assets/Orator Banners/jung-hoon-park_banner.jpg";
import stanislawDzwigajBanner from "../../assets/Orator Banners/stanislaw-dzwigaj_banner.jpg";
import haiboGeBanner from "../../assets/Orator Banners/haibo-ge_banner.jpg";
import yongSooKimBanner from "../../assets/Orator Banners/yong-soo-kim_banner.jpg";
import yaxinSuBanner from "../../assets/Orator Banners/yaxin-su_banner.jpg";
import sabahBaqiBanner from "../../assets/Orator Banners/sabah-baqi_banner.jpg";
import inayathAliKhanBanner from "../../assets/Orator Banners/inayath-ali-khan_banner.jpg";
import beatriceVincentiBanner from "../../assets/Orator Banners/beatrice-vincenti_banner.jpg";

export const orators = [
  {
    id: "mohammed-saad-al-ghamdi",
    image: mohammedSaadAlGhamdi,
    name: "Mohammed Saad Al-Ghamdi",
    from: "King Abdulaziz University, Saudi Arabia", // Reduced
    about: "Professor, Optoelectronics", // Reduced
    link: "/world-GENT-orators/mohammed-saad-al-ghamdi",
  },
  {
    id: "mark-hoffmann",
    image: markHoffmann,
    name: "Mark Hoffmann",
    from: "Univ. of North Dakota, USA", // Reduced
    about: "Associate Dean, Quantum Chemistry", // Reduced
    link: "/world-GENT-orators/mark-hoffmann",
  },
  {
    id: "jung-hoon-park",
    image: jungHoonPark,
    name: "Jung Hoon Park",
    from: "Dongguk University, South Korea", // Reduced
    about: "Researcher, Carbon Capture (CCS)", // Reduced
    link: "/world-GENT-orators/jung-hoon-park",
  },
  {
    id: "stanislaw-dzwigaj",
    image: stanislawDzwigaj,
    name: "Stanislaw Dzwigaj",
    from: "Sorbonne University, France", // Reduced
    about: "Professor, Catalysis & Surface Chemistry", // Reduced
    link: "/world-GENT-orators/stanislaw-dzwigaj",
  },
  {
    id: "haibo-ge",
    image: haiboGe,
    name: "Haibo Ge",
    from: "Texas Tech University, USA", // Reduced
    about: "Professor, Medicinal Chemistry", // Reduced
    link: "/world-GENT-orators/haibo-ge",
  },
  {
    id: "yong-soo-kim",
    image: yongSooKim,
    name: "Yong Soo Kim",
    from: "University of Ulsan, South Korea", // Reduced
    about: "Professor, Semiconductor Engg.", // Reduced
    link: "/world-GENT-orators/yong-soo-kim",
  },
  {
    id: "yaxin-su",
    image: yaxinSu,
    name: "Yaxin Su",
    from: "Donghua University, China", // Reduced
    about: "Professor, Environmental Science", // Reduced
    link: "/world-GENT-orators/yaxin-su",
  },
  {
    id: "sabah-baqi",
    image: sabahBaqi,
    name: "Sabah Baqi",
    from: "Southern Univ. of Sci. & Tech., China", // Reduced
    about: "Postdoctoral Researcher, Nanomaterials", // Reduced
    link: "/world-GENT-orators/sabah-baqi",
  },
  {
    id: "inayath-ali-khan",
    image: inayathAliKhan,
    name: "Inayath Ali Khan",
    from: "Univ. of Southern Denmark, Denmark", // Reduced
    about: "MSCA Postdoctoral Fellow, Electrochemistry", // Reduced
    link: "/world-GENT-orators/inayath-ali-khan",
  },
  {
    id: "beatrice-vincenti",
    image: beatriceVincenti,
    name: "Beatrice Vincenti",
    from: "Sapienza University of Rome, Italy", // Reduced
    about: "Technologist & PhD Student, Biomass Energy", // Reduced
    link: "/world-GENT-orators/beatrice-vincenti",
  },
];

// Detailed orator data
export const mohammedSaadAlGhamdiData = {
  id: "mohammed-saad-al-ghamdi",
  image: mohammedSaadAlGhamdi,
  from: "Professor, King Abduaziz University, Saudi Arabia",
  name: "Mohammed Saad Al-Ghamdi",
  banner: mohammedSaadAlGhamdiBanner,
  about:
    "Prof. Al-Ghamdi completed his Ph.D degrees at Cardiff University UK in 2010. Afterword he got position at King Abdulaziz University in Saudi Arabia. Then he established the optoelectronic laboratory at King Abdulaziz University. He supervised more than 10 postgraduate students and recived more than 8 funded projects form outside and inside the university. Prof. Al-Ghamdi research interest includes the design and fabrication of semiconductor devices laser diode and studies the optoelectronic and electrical properties of these devices by measuring their absorption, spontaneous, stimulated emission spectra, ideality factor, barrier height and series resistance. The current research topics include red emitters quantum dot laser diode which used in photodynamic therapy for cancer treatment and also used in the manufacture of dual wavelength sources for data storage. Prof. Al-Ghamdi has over 65 publications that have been cited over 600 times, and his publication h-index is 14. He is a member of IEEE and OSA societies.",
};

export const markHoffmannData = {
  id: "mark-hoffmann",
  image: markHoffmann,
  from: "Associate Dean for Research, University of North Dakota, USA",
  name: "Mark Hoffmann",
  banner: markHoffmannBanner,
  about:
    "Mark Hoffmann, Associate Dean for Research at UND’s College of Arts & Sciences and Chester Fritz Distinguished Professor of Chemistry, has been named a Fellow of the American Association for the Advancement of Science (AAAS) for his contributions to chemistry. Hoffmann is a leading expert in quantum chemistry, known for his groundbreaking work in molecular interactions, including the discovery of a new type of chemical bonding published in Science in 2012. He holds degrees from Northwestern University and UC Berkeley and has taught at UND since 1988. Hoffmann has chaired UND’s Chemistry Department and served as a visiting professor at prestigious institutions worldwide. His research has applications in diverse fields like catalysis, astrochemistry, and biological sciences. Hoffmann will be one of 564 AAAS Fellows announced in January 2022, a prestigious honor that dates back to 1874, recognizing significant advancements in science. He expressed gratitude for the recognition and support from UND.",
};

export const jungHoonParkData = {
  id: "jung-hoon-park",
  image: jungHoonPark,
  from: "Researcher, Dongguk University, South Korea",
  name: "Jung Hoon Park",
  banner: jungHoonParkBanner,
  about:
    "Dr. Park studied his bachelor (1988/1993), master’s degree (1996/1994) and Ph.D. (1996/2000) at the Department of Chemical Engineering of the Korea University, Seoul (Korea). From 2000 to 2013 he was a researcher at the Korea Institute of Energy Research (KIER), Daejeon (Korea). Actually, Dr. Jung Hoon Park is an Assistant Professor at the College of Engineering of Dongguk University in Seoul (Korea) and team leader of a laboratory specialized on Carbon capture and storage (CCS). His activity focuses on oxygen separation using ion transport membrane as well as hydrogen separation using metal and ceramic composite membrane, fine ceramic synthesis using hydrothermal reaction, and supercritical water extraction.",
};

export const stanislawDzwigajData = {
  id: "stanislaw-dzwigaj",
  image: stanislawDzwigaj,
  from: "Sorbonne University, France",
  name: "Stanislaw Dzwigaj",
  banner: stanislawDzwigajBanner,
  about:
    "Professor Stanislaw Dzwigaj received his PhD degree in 1982 in Jerzy Haber Institute of Catalysis and Surface Chemistry, Krakow (Poland). After two years of postdoctoral stay at the Laboratoire de Réactivité de Surface Université P. et M. Curie (Paris) he obtained in 1990 a position of contracted researcher in the same Laboratory devoted to surface reactivity in relation to catalysis phenomena. Then, in 2008 he obtained permanent position in CNRS as a researcher. On February 19, 2014 for outstanding scientific achievements, he received the title of professor. His published work includes more than 180 papers published in reputable international journals.",
};

export const haiboGeData = {
  id: "haibo-ge",
  image: haiboGe,
  from: "Texas Tech University, United States",
  name: "Haibo Ge",
  banner: haiboGeBanner,
  about:
    "Haibo Ge received his PhD degree in Medicinal Chemistry from The University of Kansas in 2006, and then moved to The Scripps Research Institute for postdoctoral study. In 2009, he began his independent academic career at the Indiana University – Purdue University Indianapolis and relocated to Texas Tech University in 2020. Research by his group is mainly focused on the development of novel methods for carbon–carbon and carbon–heteroatom bond formation through transition metal catalyzed C–H functionalization.",
};

export const yongSooKimData = {
  id: "yong-soo-kim",
  image: yongSooKim,
  from: "University of Ulsan, Korea, Republic of",
  name: "Yong Soo Kim",
  banner: yongSooKimBanner,
  about:
    "Dr. Y. S. Kim is a Professor in the Dep. of Semiconductor Engineering at the University of Ulsan, Korea. Dr. Kim earned his Ph.D. in Semiconductor Physics from Seoul National University in 1998 and has since dedicated his career to advancing semiconductor science and education. Before joining academia, he spent a decade at SK-Hynix Semiconductor Inc. as a principle researcher, where he contributed to the development of high-performance memory devices, including dual-poly metal gate and high-performance ALD technologies. His academic research focuses on 2D transition metal dichalcogenides (TMDCs), valleytronics, polaritons, and neuromorphic memory devices. He has led multiple national research projects funded by the NRF and KEIT of Korea, so on, emphasizing next-generation optoelectronics and green energy materials. His recent publications cover topics such as strong exciton-photon coupling, valley polarization in 2D materials, and microcavity design.",
};

export const yaxinSuData = {
  id: "yaxin-su",
  image: yaxinSu,
  from: "Donghua University, China",
  name: "Yaxin Su",
  banner: yaxinSuBanner,
  about:
    "Dr Su is a professor at the School of Environmental Science and Engineering, Donghua University, China. Currently he serves as the chair of Department of Built Environment and Energy Engineering. He received his Ph D from Zhejiang University, China, in 2000. He worked in Department of Chemical Engineering, University of Mississippi, USA as visiting professor during 2006-2007. He has published 3 academic books, 5 textbooks and 1 academic book chapter, more than 100 research articles in SCI (E) journals, covering gas-solid suspension flow and separation, thermo-chemical conversion of solid fuels, selective catalytic reduction of NOx and new catalysts, CO2 capture, etc.",
};

export const sabahBaqiData = {
  id: "sabah-baqi",
  image: sabahBaqi,
  from: "Southern University of Sciences and Technology, China",
  name: "Sabah Baqi",
  banner: sabahBaqiBanner,
  about:
    "Dr. Sabah Baqi studied Physics at the University of Peshawar, Pakistan, and graduated as a gold medallist with a BS degree. She then joined the Department of Physics at the National University of Sciences and Technology (NUST), Islamabad, where she earned her MPhil degree with a focus on tuning the optical and dielectric properties of nanomaterials for optoelectronic applications. She received her PhD degree from the City University of Hong Kong, where her research involved the synthesis of photoelectrodes and their application in photoelectrochemical cells, particularly for hydrogen evolution via water splitting. After completing her PhD, she worked as a Senior Research Assistant at The University of Hong Kong, focusing on the optimization of high-k materials through ion implantation and co-doping techniques. She is currently a postdoctoral researcher and has published multiple research articles in SCI(E)-indexed journals.",
};

export const inayathAliKhanData = {
  id: "inayath-ali-khan",
  image: inayathAliKhan,
  from: "University of Southern Denmark, Denmark",
  name: "Inayath Ali Khan",
  banner: inayathAliKhanBanner,
  about:
    "Dr Inayat Ali Khan, PhD graduated from Quaid-i-Azam University in 2017 with a doctorate in Analytical and Inorganic Chemistry. From June 2019 to September 2021, he engaged in postdoctoral research to design halogen free ionic liquids for green energy application at the Luleå University of Technology (LTU), Sweden. In October 2022, he started another postdoc project on PEM water electrolyzers to produce protype and industrial scale quality electrocatalysts at the University of Southern Denmark (SDU), Denmark. Currently, he is working as a Marie Skłodowska-Curie Postdoctoral Fellow (MSCA-PF-2023) under the Horizon-Europe 2021-2027 framework program at IGT, SDU, Denmark.",
};

export const beatriceVincentiData = {
  id: "beatrice-vincenti",
  image: beatriceVincenti,
  from: "Sapienza University of Rome, Italy",
  name: "Beatrice Vincenti",
  banner: beatriceVincentiBanner,
  about:
    "Dr. Beatrice Vincenti is currently a Technologist at the Council for Agricultural Research and Economics, Center of Engineering and Agro-Food Processing (CREA-IT), where she carries out her research activity on the reuse of biomass from agroforestals as an energy source in a circular economy perspective. At the same time, she is a PhD student at Sapienza University in Rome, where she works on the optimization of biomass gasification processes. Graduated in Analytical Chemistry from the Sapienza University, she is now a member of the National Order of Chemists and Physicists and participates as a Member of Scientific Committees and Reviewer in several national and international conferences.",
};

// Map for lookup
export const orators_details_map = {
  "mohammed-saad-al-ghamdi": mohammedSaadAlGhamdiData,
  "mark-hoffmann": markHoffmannData,
  "jung-hoon-park": jungHoonParkData,
  "stanislaw-dzwigaj": stanislawDzwigajData,
  "haibo-ge": haiboGeData,
  "yong-soo-kim": yongSooKimData,
  "yaxin-su": yaxinSuData,
  "sabah-baqi": sabahBaqiData,
  "inayath-ali-khan": inayathAliKhanData,
  "beatrice-vincenti": beatriceVincentiData,
};